import React, { useState } from "react";
import styled from "styled-components";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
// Assets
import ProjectImg1 from "../../assets/img/logo/egurad.png";
import ProjectImg2 from "../../assets/img/logo/people.png";
import econnectLogo from "../../assets/img/logo/econnect_icon.png";
import careworksLogo from "../../assets/img/logo/careworks-logo.JPG";
import alldaylogo from "../../assets/img/logo/all-day-logo.png";


import c6 from "../../assets/img/c6.jpg";
import bs1 from "../../assets/img/bs1.jpg";
import bs2 from "../../assets/img/bs2.jpg";
import bs3 from "../../assets/img/bs3.jpg";
import bs4 from "../../assets/img/bs4.jpg";
import cp1 from "../../assets/img/cp11.jpg";
import cp2 from "../../assets/img/cp12.jpg";
import cp3 from "../../assets/img/cp13.jpg";
import cp4 from "../../assets/img/cp14.jpg";
import cp5 from "../../assets/img/cp15.jpg";
import cp6 from "../../assets/img/cp16.jpg";
import cp7 from "../../assets/img/cp17.jpg";
import mp1 from "../../assets/img/mp-1.jpg";
import mp2 from "../../assets/img/mp-2.jpg";
import p1 from "../../assets/img/p1.jpg";
import p2 from "../../assets/img/p2.jpg";
import p3 from "../../assets/img/p3.jpg";
import p4 from "../../assets/img/p4.jpg";
import p5 from "../../assets/img/p5.jpg";
import p6 from "../../assets/img/p6.jpg";
import p7 from "../../assets/img/p7.jpg";
import c1 from "../../assets/img/c1.jpg";
import c2 from "../../assets/img/c2.jpg";
import c3 from "../../assets/img/c3.jpg";
import c4 from "../../assets/img/c4.jpg";
import c5 from "../../assets/img/c5.jpg";
import ts1 from "../../assets/img/ts1.jpg";
import ts2 from "../../assets/img/ts2.jpg";
import ts3 from "../../assets/img/ts3.jpg";
import ts4 from "../../assets/img/ts4.jpg";
import ts5 from "../../assets/img/ts5.png";
import ts6 from "../../assets/img/ts6.jpg";
import cw1 from "../../assets/img/cw1.jpg";
import cw2 from "../../assets/img/cw2.jpg";
import cw3 from "../../assets/img/cw3.jpg";
import cw4 from "../../assets/img/cw4.jpg";
import edu5 from "../../assets/img/edu5.png";

export default function Projects() {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal = () => setOpen(false);
  const onCloseModal1 = () => setOpen1(false);
  const [open2, setOpen2] = useState(false);
  const onOpenModal2 = () => setOpen2(true);
  const onCloseModal2 = () => setOpen2(false);
  const [open3, setOpen3] = useState(false);
  const onOpenModal3 = () => setOpen3(true);
  const onCloseModal3 = () => setOpen3(false);
  const [open5, setOpen5] = useState(false);
  const onOpenModal5 = () => setOpen5(true);
  const onCloseModal5 = () => setOpen5(false);
  const [open6, setOpen6] = useState(false);
  const onOpenModal6 = () => setOpen6(true);
  const onCloseModal6 = () => setOpen6(false);
  const [open7, setOpen7] = useState(false);
  const onOpenModal7 = () => setOpen7(true);
  const onCloseModal7 = () => setOpen7(false);
  const [open8, setOpen8] = useState(false);
  const onOpenModal8 = () => setOpen8(true);
  const onCloseModal8 = () => setOpen8(false);
  const [open9, setOpen9] = useState(false);
  const onOpenModal9 = () => setOpen9(true);
  const onCloseModal9 = () => setOpen9(false);

  return (
    <Wrapper id="projects">
      <div style={{ padding: "60px 0 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold text-center mb-20">
              Products & Services
            </h1>
            <p className="font13">
              Shripati Group Companies are focused Multi channel Services &
              Product Integration Service providers providing complete domain
              based eo-solution in citizen centric interactivity & mobility. We
              deliver agile & adaptive solutions and our products are based on
              web technology with various domain based users using our products
              and services on site based, SAAS based and T&M based business
              Models. Our Health care Turnkey Service is a Uniqque BOM(Build,
              Operate & Manage Model) which provide Consistent and Management
              Control audits over projected and Pro-active planned way for any
              hospital development and its scalling up state.
            </p>
            <p>
              Our Group Companies providing under mentioned products & services
              are:
            </p>
            <ul className="list">
              <li>All Day Digital</li>
              <li>Sofscript Systems & Services Ltd.</li>
              <li>All Day Health Catalyst Pvt. Ltd.</li>
            </ul>
            <br />

            <div className="row">
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="e-Guard Document Shield" src={ProjectImg1} />
                  <h4>e-Guard Document Shield</h4>
                  <p>
                    One of our (STS) unique solution in field of Document
                    anti-counterfeiting is numero Uno solution which is an
                    integration of RFID embedded Technology along with IOT
                    creating a platform for smart and secured Document
                    transactions.
                  </p>
                  <button onClick={onOpenModal} className="btn">
                    Read More
                  </button>
                  <Modal open={open} onClose={onCloseModal} center>
                    <h3>e-Guard Document Shield</h3>
                    <div className="modal-body">
                      <p>
                        One of our (STS) unique solution in field of Document
                        anti-counterfeiting is numero Uno solution which is an
                        integration of RFID embedded Technology along with IOT
                        creating a platform for smart and secured Document
                        transactions.
                      </p>
                      <p>
                        e-Guard Document Shield is a complete document
                        anti-counterfeiting transactional eco-system for
                        securing documents by embedding digital mask based on
                        Smart chip with a physical document giving 100% zero
                        tolerance environment for preventing
                        creations/circulations of fake documents in public
                        domains &amp; provide complete document transaction
                        connecting various stakeholders. The eco-system is
                        designed in a way that it provides versatility
                        Intelligence in the core engine so that the same
                        eco-system can be used for various business Domains
                        which are as followings:
                      </p>
                      <ul className="list">
                        <li>
                          Education &amp; Academic Transcripts (Universities
                          Degrees)
                        </li>
                        <li>
                          Municipalities (Death, Birth And Marriage
                          Certificates)
                        </li>
                        <li>
                          Land &amp; Revenue Sectors (Property Registrations
                          Documents)
                        </li>
                        <li>
                          For verification and validation of Pharma and other
                          consumable Products
                        </li>
                      </ul>

                      <p>
                        <b>
                          <u>
                            e-Guard Document Shield for Education &amp; Academic
                            Documents
                          </u>
                        </b>
                      </p>
                      <p>
                        Today worldwide Universities and Education Institutes
                        are facing issues of fake Degrees and Certificates. Fake
                        Degrees &amp; Certificates remains one of the major
                        concerns for all academic institutes. It takes ages to
                        build a Brand for any academic institute by implementing
                        quality by process and learning methodologies but a
                        single lot of fake degrees in market proves to be a
                        blatant blow to the Brand giving direct &amp; in-direct
                        revenue &amp; opportunity loss to the University or
                        education Institutes.
                      </p>
                      <p>
                        e-Guard document Shield eco-solution provides
                        University, a unique mix of technology and Knowledge
                        based business environment by providing digital mask
                        Degrees as per eight year license execution and
                        activating those Digital secured degrees with e-Guard
                        Document Shields platform. This enables University
                      </p>
                      <p>
                        The activation process of Individual degrees will enable
                        the University to showcase their Students secured
                        degrees for an outside world claiming Zero tolerance for
                        Fake Degrees by allowing their degrees to go for online
                        verification with Real time super image of the Student
                        data from University server which are in the custody of
                        University at university premises. The Process of online
                        verification by an end-user
                        (Corporate–Private/Government, Consulates, Institutes
                        other national/International bodies) will also provide
                        flexibility for a University as an additional Revenue
                        from Degrees Verification of students by a way of
                        Transactional fee (from e-Guard payment Bridge) for
                        verifying Student data and showing super image of the
                        student Degree/other Relevant details on real time
                        basis.
                      </p>

                      <p>
                        <b>
                          <u>
                            Following Tangible benefits are listed for
                            Universities and Educational institutes
                          </u>
                        </b>
                      </p>
                      <ul className="list">
                        <li>
                          Solution Guarantees Zero tolerance to fake Degrees and
                          Fake Certificates
                        </li>
                        <li>
                          Enhance &amp; secure University/Institute Brand by
                          granting &amp; claiming genuine Awards.
                        </li>
                        <li>
                          Solution implementation from day one will bring
                          Institute /University
                          <ul className="list">
                            <li>In league of Technology Driven Institutes</li>
                            <li>
                              Closer to online/outside world bringing access to
                              international/National corporate/bodies/consulates
                              worldwide
                            </li>
                            <li>
                              Future employability and student acceptance in the
                              industry
                            </li>
                            <li>
                              Automations of online verifications process on
                              acceptable Industry standards
                            </li>
                            <li>Revenue from online Verifications</li>
                            <li>
                              Online Value added Service with SMS Manager for
                              University to send various broadcast messages to
                              Students for Degree Convocation programs
                            </li>
                            <li>
                              Issuance &amp; Re-issuance integrated application
                            </li>
                            <li>
                              Water mark signature with 128bit encryption
                              mechanism
                            </li>
                            <li>
                              Access to registered Corporates/Consulates with
                              Environment for verifications
                            </li>
                            <li>
                              Degree and Academic data on University Premises
                              Servers
                            </li>
                            <li>Access to Registered Corporates</li>
                            <li>
                              ISO 27001 Data security Audit compliances Report
                              for University so that Data And Information
                              security Certificates can be Achieved.
                            </li>
                            <li>
                              5 years Degree Warranty and life time Degree
                              Verification Support for University/Institute
                            </li>
                          </ul>
                        </li>
                      </ul>

                      <p>
                        Will Bring DEGREE/TESTIMONIAL of the University as a
                        SALES KIT INSTRUMENT for Students/their parents and
                        outside Industry.
                      </p>
                      <p>
                        <b>
                          <u>e-Guard Document Shield for Municipalities</u>
                        </b>
                      </p>
                      <p>
                        Today's Municipalities are facing issues of fake
                        Documents (Birth &amp; Death Certificates) and this
                        issue remains as one of the major concerns for over
                        India and other countries. It takes ages to build a
                        brand for any Municipalities by implementing quality by
                        process and learning methodologies but a single lot of
                        fake Birth &amp; Death Certificates in market prove a
                        blatant blow to the brand and also in-directly give
                        revenue &amp; opportunity loss to the Municipalities.
                      </p>

                      <p>
                        The activation process of Individual Birth &amp; Death
                        Certificate will enable the Municipality to showcase
                        their secured documents for an outside world claiming
                        Zero tolerance for fake Birth &amp; Death Certificates
                        by allowing their issued certificates to go for remote
                        validation check and simultaneously going for an online
                        verification with real time /on request authenticity of
                        the citizen Birth &amp; Death data from municipality
                        server which are in the custody of municipality premises
                      </p>

                      <p>
                        <b>
                          <u>
                            e-Guard Document Shield for Land &amp; Revenue
                            Sector
                          </u>
                        </b>
                      </p>
                      <p>
                        Property Registration provides the property owner with
                        legal sanctity for the purchase transaction executed on
                        the property during transfer of ownership. Property
                        Registration in India is governed by the Indian
                        Registration ACT, 1908 and the Indian Stamp ACT, 1899.
                        The state-wise Registration and the Stamps department is
                        entrusted with the responsibility of administrating
                        these acts through collection of registration Fee and
                        Stamp Duty (as stipulated in the state –wise Stamp Acts)
                        and executing the sale/transfer of property /Title deeds
                        and the registered sale deed document protects an
                        individual's ownership rights over the property and is a
                        vital "proof of property transaction” that is accepted
                        by the Indian court of law in the case of property
                        related disputes.
                      </p>

                      <p>
                        However over the years several instances of documents
                        forgery, duplication and faking have led to illegal
                        property transactions and false claims on property
                        ownership , resulting in many legal disputes and several
                        bonefide property investors across the country being
                        duped. Producing fake property /title documents is also
                        a common method used by fraudsters/land mafias to
                        deceive banks /HFCs into providing property loans on
                        illegally acquired/nonexistent property, or to get
                        multiple financing on the same property.
                      </p>
                      <p>
                        The risks associated with such counterfeit title deed
                        documents are significant and have direct implications
                        on the property transaction eco-system in the country,
                        and in securing the ownership rights of bonefide
                        property owners. Document security and integrity is
                        absolutely essential for the effective governance of
                        property transactions and to uphold the sanctity of the
                        registered document as an authentic "Proof of Ownership"
                      </p>

                      <p>
                        Thus registration of a property becomes the most
                        important legal formality of any property transaction
                        and any non-compliance with this process (avoidance of
                        registration and evasion of Stamp duty) and/or
                        falsification of documents/information while executing
                        the transaction (Fake Stamp Instruments, Falsifications
                        of property Details/ownership) results in violation of
                        the Registration and Stamp Acts and is potentially
                        punishable offence according to law.
                      </p>
                      <p>
                        The process of property registration of Sale/Transfer
                        deeds has in itself a legal sanctity that assigns a new
                        ownership of the property to the buyer. However, the
                        lack of authentic property related documents that are
                        used in otherwise legally valid registration
                        transactions, has given rise to fraud in property
                        transactions.
                      </p>

                      <p>
                        There are frequent false claims of ownership involving
                        the use of fake/forged property documents to illegally
                        occupy properties and execute transfer/sale transactions
                        with gullible buyers. Today the scenario is "Anyone who
                        wants to enter into an immovable property transaction is
                        expected to investigate its title themselves. If one
                        un-knowingly buys a detective title, the only remedy is
                        litigation as no guarantee is offered by the State".
                      </p>

                      <p>
                        The Property sector boom in India and other countries
                        and the resulting exponential growth in registration
                        volumes has made governance of land registrations a very
                        complex situation. Property fraud constitutes a major
                        portion of all fraud reported. The menace of fake title
                        deed documents has also had significant impact on the
                        Banking and Housing finance sector. Title deed documents
                        (which are necessary requirement for banks to sanction
                        property loans) are faked by individuals in order to
                        gain loans for illegally acquired
                        properties/unauthorized properties. Moreover, this
                        method of faking registered sale deed documents is a
                        common practice for gaining multiple loans from
                        different banks, as the original sale deed is retained
                        by the bank that sanctioned the first loan.
                      </p>

                      <p>
                        Lately, many states government have taken initiatives to
                        upgrade the technology and using ICT supporting the
                        process of property registration. Different state
                        governments are at different levels of maturity in terms
                        of computerization of registration. In many states, the
                        process of registrations involves scanning of registered
                        documents, taking photographs and biometrics of
                        executing parties and system generated serialization of
                        registrations. These initiatives and smoothening of the
                        initiatives have helped the Registration Department in
                        simplifying, speeding up and improving efficiency in the
                        registration process and smoothening of
                        Government-Citizen interface.
                      </p>

                      <p>
                        While the Current technology upgrade initiatives are
                        welcome but the fact is that the problem is still at
                        large and system of registrations (Registered sale
                        Deeds) offer no further assurance to the title that
                        claimed by the Seller/Property Owner to various
                        stakeholders in the process.
                      </p>

                      <p>
                        e-Guard Document Shield platform is numero Uno Land
                        &amp; Revenue sector e-Governance platform giving
                        end-to-end solution for operational and global
                        challenges faced by land &amp; Property registration
                        transactional eco System in terms of managing
                        transparency and trust in the system with respect to
                        excellence by business processes and technology. It aims
                        in driving governance, accountability and trust with in
                        all stakeholders who are involved continuously in the
                        process for making Real estate and Property Sectors in
                        India continuously on growth pangs.
                      </p>

                      <p>
                        The e-Guard Document Shield anti-counterfeiting features
                        provide an undisputed ownership right on the property,
                        and provide property registration department to secure
                        the authentic registration title deed from being
                        tampered with or faked, and to also provide a secure way
                        of authenticating the genuineness of this ownership
                        document. To achieve this, the system provide a unique
                        “tamper evident- non-duplicable “ feature by embedding
                        secured watermarked 128 bits encrypted masking on the
                        registered document which will be activated with the
                        platform thus providing 'foolproof' mechanism to verify
                        and validate the ownership claim of an individual on the
                        property. Our e-guard Document shield governance
                        platform provide an eco-transactional system which
                        provide a platform of "Single Source of Truth" regarding
                        property ownership.
                      </p>

                      <p>
                        The Governance platform provides built-in, systematic
                        controls for secure and effective Due Diligence and
                        foolproof document security during the registration
                        process. The anti-counterfeiting feature would help the
                        Buyer / Banks /Government /Housing loans providers to
                        verify and validate the Registered deed document from
                        being used to claim a demonstrate ownership over a
                        property on a real time basis and the feature also
                        provide flexibility for a state revenue and registration
                        department to get an additional revenue by using a
                        payment bridge of the platform for real time
                        validation/verifications and provide zero tolerance
                        environment to fake sale/Transfer deeds.
                      </p>

                      <p>
                        <b>
                          <u>
                            e-Guard Document Shield for Pharma and Consumable
                            products verification &amp; Validation.
                          </u>
                        </b>
                      </p>

                      <p>
                        Today industry for Pharma products and other consumable
                        products are also facing a challenge of fake products
                        distribution faking products bundled in the reputed
                        national and international product banners . People
                        using these products are not sure if they are getting
                        products of original vendor or the fake product is
                        wrapped under the banner of the known industry. Now
                        Various Pharma companies and other consumable product
                        companies can use our e-Guard Document shield
                        eco-solution Mobile app Validation and verification
                        mechanism by end-users to verify and validate the
                        sanctity of the product as it has three layers
                        verification mechanism which guarantees zero tolerance
                        for fake products distribution in the market.
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Health" src={ProjectImg2} />
                  <h4>e-PeoplePlus Smart & Connected Health</h4>
                  <p>
                    HealthCare is seeing steady and increasing dependence on
                    information technology that is rapidly transforming the
                    practice of medicine and the delivery of healthCare. Four
                    primary drivers for health care providers which drives them
                    to ...
                  </p>
                  <button onClick={onOpenModal1} className="btn">
                    Read More
                  </button>
                  <Modal open={open1} onClose={onCloseModal1} center>
                    <h3>e-PeoplePlus Smart & Connected Health</h3>
                    <div className="modal-body">
                      <p>
                        Today Healthcare is seeing s steady and increasing
                        dependence on information technology that is rapidly
                        transforming the practice of medicine and the delivery
                        of healthcare. Four primary drivers for health care
                        providers which drives them to increase the use of
                        technology in health care:
                      </p>

                      <ul className="list">
                        <li>
                          The need to lower costs and create administrative
                          efficiencies.
                        </li>
                        <li>
                          The need to improve patient outcomes and enhance
                          physicians &amp; patient relations
                        </li>
                        <li>
                          The need to meet increasing privacy, Security and
                          Identity concerns as a result of healthcare federal
                          directives mandating increase control over health
                          information
                        </li>
                        <li>
                          The need to provide Value Added Services to meet and
                          survive market competition
                        </li>
                      </ul>

                      <p>
                        Also we have been taught from our childhood that "HEALTH
                        IS WEALTH" and we believe that the greatest gift any
                        person can give to his or her family and to the world is
                        healthy him or her . Today everybody is talking about
                        smart city environment and with growth in mobility and
                        social networks we can-not imagine our life without our
                        friends and near and dear ones in our society and we
                        call ourselves a socially connected society .But,
                        ironically our social network so calls "Socially
                        connected environment" failed to give us smart and
                        connected health environment which is the need of an
                        hour today.
                      </p>

                      <p>
                        <b>
                          <u>
                            As a citizen my expectations from healthcare
                            eco-system for distress situations:
                          </u>
                        </b>
                      </p>
                      <ul className="list">
                        <li>
                          In Emergency/Distress when I call for medical
                          emergency the health system should identify me
                        </li>
                        <li>My location should be known automatically</li>
                        <li>
                          Logistic for my immediate transfer to the nearest
                          health provider should be arranged for providing me
                          medical assistance
                        </li>
                        <li>
                          My Previous medical record should be available in the
                          system so that proper medical treatment should be
                          started on immediate basis.
                        </li>
                        <li>
                          My payer and co-payer should be known so that I should
                          be given best available treatment for my medical
                          emergency on immediate basis
                        </li>
                      </ul>

                      <p>
                        <b>
                          <u>
                            As a citizen my expectations from healthcare
                            eco-system for planned/general illness situation
                          </u>
                        </b>
                      </p>

                      <ul className="list">
                        <li>
                          I can access my medical record anytime anywhere
                          despite of my different touch points at various
                          clinics/labs and hospitals
                        </li>
                        <li>
                          I can be offered discounts as a privilege service user
                          for my loyalty towards health service provider
                        </li>
                        <li>
                          I can also be offered discounts on various health care
                          services from my health care service provider/I Health
                          insurer alliances
                        </li>
                        <li>
                          My Previous medical record should be available in the
                          system so that proper medical treatment should be
                          started on immediate basis.
                        </li>
                        <li>
                          My payer and co-payer should be known so that I should
                          be given best available treatment for my medical
                          emergency on immediate basis
                        </li>
                      </ul>

                      <p>
                        So we define smart and connected environment as shown in
                        figure below
                      </p>

                      <p align="center">
                        <img alt="img" src={c6} />
                      </p>

                      <p>
                        There are various stakeholders of this smart and
                        connected health eco-system which are actively involved
                        in providing safety and security providing protection to
                        citizens including themselves and to their near and
                        dears from mortality and morbidity thus providing
                        society a better health care connected environment.
                      </p>
                      <p>
                        Citizens are connected to this environment by issuing a
                        Smart Health Cards.
                      </p>
                      <p>
                        Various Stake holders which are connected to eco
                        solutions are
                      </p>

                      <ul className="list">
                        <li>Citizens are connected with Smart Health cards</li>
                        <li>
                          Clinics and hospitals as Registered EHR providers
                        </li>
                        <li>Medicos &amp; Pharmas as B2c Units</li>
                        <li>
                          Payers &amp; Insurance as Insurance or Payment Units
                        </li>
                        <li>Corporates </li>
                        <li>
                          Doctors/clinics/hospitals providing as telemedicine
                          Service Providers
                        </li>
                        <li>
                          Emergency Response/ambulatory/Disaster management
                          units under emergency response Radar service providers
                        </li>
                        <li>
                          Entertainment/eateries/Parking service Providers under
                          B2C Service Providers
                        </li>
                        <li>Government &amp; regulators </li>
                      </ul>
                      <p align="center">
                        <img alt="bs1" src={bs1} />
                      </p>
                      <p align="center">
                        <img alt="bs2" src={bs2} />
                      </p>
                      <p align="center">
                        <img alt="bs3" src={bs3} />
                      </p>
                      <p align="center">
                        <img alt="bs4" src={bs4} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Connect Plus" src={econnectLogo} />
                  <h4>Connect Plus</h4>
                  <p>
                    While automotive digital technology has traditionally
                    focused on optimizing the vehicle's internal functions,
                    attention is now turning to developing the car's ability to
                    connect with the outside world and enhance the in-car
                    experience.
                  </p>
                  <button onClick={onOpenModal2} className="btn">
                    Read More
                  </button>
                  <Modal open={open2} onClose={onCloseModal2} center>
                    <h3>Connect Plus</h3>
                    <div className="modal-body">
                      <p>
                        While automotive digital technology has traditionally
                        focused on optimizing the vehicle's internal functions,
                        attention is now turning to developing the car's ability
                        to connect with the outside world and enhance the in-car
                        experience. This is the <i>connected car</i> —a vehicle
                        able to optimize its own operation and maintenance as
                        well as the convenience and comfort of passengers using
                        onboard sensors and Internet connectivity.
                      </p>

                      <p>
                        The vehicle technologies currently available are only a
                        fraction of what is being developed for the future. The
                        technologies for autonomous cars, connected cars, and
                        advanced driver assistance systems overlap. Connect Plus
                        is a unique environment that connects vehicle and driver
                        of the car with an outside world giving some of the very
                        practical vehicle connectivity and driver behind
                        steering experience.
                      </p>

                      <p>
                        The connect plus environment is a cloud application
                        environment
                      </p>

                      <p align="center">
                        <img alt="cp1" className="w-100" src={cp1} />
                      </p>

                      <p>
                        And the environment primarily issues a smart vehicle
                        card for the owner which holds basic vehicle data and
                        also act as a brand identity for specific vehicle .
                        Various stake holders of connect plus environment is
                        shown in figure below
                      </p>

                      <p align="center">
                        <img alt="cp2" className="w-100" src={cp2} />
                      </p>

                      <p>
                        Following are the industry drivers that drive the
                        benefits of the eco-solution
                      </p>

                      <p align="center">
                        <img alt="cp3" className="w-100" src={cp3} />
                      </p>

                      <p align="center">
                        <img alt="cp4" className="w-100" src={cp4} />
                      </p>

                      <p align="center">
                        <img alt="cp5" className="w-100" src={cp5} />
                      </p>

                      <p align="center">
                        <img alt="cp6" className="w-100" src={cp6} />
                      </p>

                      <p>
                        Connect plus environment is also called as smart and
                        connected
                      </p>

                      <p align="center">
                        <img alt="cp7" className="w-100" src={cp7} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img
                    className="round"
                    alt="CareWorks HIMS"
                    src={careworksLogo}
                  />
                  <h4>CareWorks HIMS</h4>
                  <p>
                    CAREWORKS<sup>™</sup> is an Integrated Hospital Management
                    System. CAREWORKS<sup>™</sup> is a One-Stop Integrated
                    Solution comprising of Hospital Management System,
                    Laboratory Information System and Mobile Applications
                    including Tele-Medicine, Tele-Consultation and
                    e-Prescribing.
                  </p>
                  <button onClick={onOpenModal3} className="btn">
                    Read More
                  </button>
                  <Modal open={open3} onClose={onCloseModal3} center>
                    <h2>CareWorks HIMS</h2>
                    <div className="modal-body">
                      <p>
                        CAREWORKS<sup>™</sup> is an Integrated Hospital
                        Management System. CAREWORKS<sup>™</sup> is a One-Stop
                        Integrated Solution comprising of Hospital Management
                        System, Laboratory Information System and Mobile
                        Applications including Tele-Medicine, Tele-Consultation
                        and e-Prescribing. Successfully installed in over 100
                        prestigious hospitals across 19500+ beds with large
                        facilities offering the most comprehensive range of
                        healthcare services and also Hospitals with multi-site
                        business operations.
                      </p>
                      <p>
                        It has been an instrumental factor in the growth of
                        several world class hospitals such as MP Birla Hospital
                        in Chittorgarh, Saifee Hospital in Mumbai, Bombay
                        Hospital in Mumbai & Indore, Sterling Group of 6
                        Hospitals, KLES Group of 5 Hospitals, St. John's Medical
                        College in Bangalore, Christian Medical College in
                        Ludhiana, Jaslok Hospital in Mumbai and many more.
                      </p>
                      <p>
                        Because of our over two-decade long association with the
                        world's leading healthcare providers, CAREWORKS
                        <sup>™</sup>
                        includes <strong>'fully integrated'</strong>{" "}
                        functionalities and <strong>'best practices'</strong>{" "}
                        pertaining to the current trends in healthcare industry
                        and present market scenario. CAREWORKS<sup>™</sup>{" "}
                        covers major hospital and laboratory functions related
                        to patients, general practitioners, specialists,
                        surgeons and other medical professionals, nurses,
                        pharmacists, I.T and purchase managers, accountants,
                        hospital administrators and top management.
                      </p>
                      <p>
                        <strong>
                          The Hospital's Top Management can have an eagle-eye of
                          the departments in the hospital relating to incomes &
                          expenditure, generating real-time reports with
                          bar-diagrams and pie-charts for timely decision making
                          and effective management calls.
                        </strong>
                      </p>
                      <p>
                        <img alt="cw1" className="w-100" src={cw1} />
                      </p>
                      <p>
                        It Module based deployment approach allows organisations
                        to quickly launch programs and build new features upon
                        these. This results in minimum operational downtime of
                        the functioning department. Besides providing automation
                        framework for medical and clinical processes, it also
                        provides strong backbone for material and financial
                        management fully integrated in one single solution. By
                        deploying its “ERP-like” best practices, CAREWORKS™
                        users have reported substantial “monetary” benefits
                        because of improved asset management & resource
                        utilization, reduction in wasteful consumption, major
                        gains in inventory carrying costs, and improvements in
                        clinical processes and operational efficiency. All this,
                        while simultaneously improving the quality and accuracy
                        of "patient services".
                      </p>
                      <p>
                        In addition to a top-of-the-line HMIS, there are more
                        reasons to engage:
                      </p>
                      <ol className="list">
                        <li>
                          <strong>PACS & DICOM</strong> connectivity{" "}
                        </li>
                        <li>
                          <strong>HL7 Compliant</strong> – successfully deploy a
                          Global Healthcare Delivery Model.{" "}
                        </li>
                        <li>
                          <strong>Mobile Applications</strong> – to provide an
                          Intelligent & Context Sensitive Healthcare Environment{" "}
                        </li>
                      </ol>

                      <p>
                        CAREWORKS<sup>™</sup> is configured as a
                        state-of-the-art modular system making the best use of
                        system hardware/software and application software.
                      </p>
                      <p>
                        Since Information Technology is evolving very quickly
                        supported by attractive tools, we use the latest yet
                        most reliable options considering the hospital's
                        investment protection over a period of time. For healthy
                        management of hospitals, a modular software system
                        CAREWORKS™ has been configured following years of
                        mapping systems and process flow in hospitals so as to
                        integrate the activities of inter-related functions and
                        departments. Sensitive to the constant advancement in
                        techniques and technology, reasonable effort goes into
                        providing value for money through deployment of current
                        but stable tools and technologies. Also, the need to
                        scale up, integrate with other systems have been kept in
                        mind while designing the software. The result has been
                        simple, flexible yet modern ERP system that not only
                        facilitates efficient and brisk operations, but also
                        presents MIS in spreadsheet, charts or graphical forms
                        at the touch of a button. Speaking technically, the
                        proposed system works on a multi tire architecture where
                        the hardware is a network of several workstations with a
                        large Application Data Stores (ADS). The proposed system
                        allows DICOM / Non-DICOM image transmission across the
                        hospital and other locations, use of WEB based
                        applications, scanners, Smart Card, Palm Tops, sending /
                        receiving messaging through SMS etc.
                      </p>
                      <p>
                        The clean Graphic User Interface (GUI) makes man-machine
                        interface user-friendly, fluid and smooth transitions,
                        pleasing to the eye, and the currently available OLE
                        tools present critical information in an attractive
                        manner. Thus, rather than just a data entry tool used
                        only for making hospital operations efficient and fast,
                        CAREWORKS<sup>™</sup> elevates itself as an advanced
                        management information tool with easy-to-handle screens
                        and graphical presentation of various management
                        information at the touch of a button.
                      </p>
                      <p>
                        Our application for the Hospitals is a complete Hospital
                        Management System. The fully integrated system renders
                        the administrative and medical support duties smooth and
                        effective thereby enabling the hospital to concentrate
                        more on patient care.
                      </p>
                      <p>
                        <img alt="cw2" className="w-100" src={cw2} />
                      </p>
                      <p>
                        Based on the functionality, the modules can be
                        categorized into four broad groups (i.e., Front office
                        Systems, Medical Systems, Administrative Systems and
                        Back Office Systems)
                      </p>
                      <ol className="list">
                        <li>
                          <strong>Front Office System</strong> - Provides
                          services across the counter to patients such as
                          Patient Registration, Deposit Collections, OP Visits,
                          Reservations, Allotments, Out Patient Billing & Cash
                          Handling, In Patient Administration, In Patient
                          Billing & Cash Handling, Pharmacy and Night Auditing
                          modules. These are the base modules for patient
                          management.{" "}
                        </li>

                        <li>
                          <strong>Medical System</strong> – Caters to the upkeep
                          of various records such as Laboratory module for test
                          reports, CPOE, Operation Theatre scheduling, Blood
                          Bank, Nurse Station, Medical Records, Medical Folder
                          Tracking, OPD patient's Case History, Cath lab reports
                          and Stress Test reports.
                        </li>

                        <li>
                          <strong>Back Office System</strong> – Handles
                          back-office functions such as Inventory Management,
                          Credit Companies Accounting, Doctors Accounting,
                          Financial Accounting, General Stores, Purchase &
                          Vendor Management.{" "}
                        </li>

                        <li>
                          <strong>Administrative System</strong> – Ensures
                          efficient management of various administrative
                          functions such as Equipment Financials, AMC's,
                          Depreciation, Down-time with Maintenance Schedules,
                          CSSD, Patient Complaint Monitoring, Maintenance
                          Tracker, and Linen & Laundry Management. Also includes
                          User Setup and Head Cashier{" "}
                        </li>
                        <li>
                          <strong>Interface Connectivity Messaging</strong>
                          <ul className="list">
                            <li>
                              Connectivity with DICOM imaging equipment like
                              X-ray/CT, PACS is also possible
                            </li>
                            <li>
                              Smart card/Swipe cards can be interfaced with our
                              time attendance and payroll systems.
                            </li>
                            <li>
                              Barcode Based Inventory Control and Lab Sample
                              Identification
                            </li>
                            <li>
                              Web Based Interface for reservation and
                              appointments
                            </li>
                            <li>
                              Auto messaging Doctor/Patient alerts Using SMS
                            </li>
                            <li>
                              Connectivity to EPABX for Billing Calls and
                              Information on Hospital Bills{" "}
                            </li>
                          </ul>
                        </li>
                      </ol>
                      <br></br>
                      <p>
                        <strong>
                          Careworks Integrated HIMS Implementations{" "}
                        </strong>
                      </p>
                      <p>
                        <img alt="cw3" className="w-100" src={cw3} />
                      </p>
                      <p>
                        <img alt="cw4" className="w-100" src={cw4} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>

              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Turnkey Service" src={ProjectImg2} />
                  <h4>
                    Comprehensive Health & Wellness Program for School students
                    and their Family
                  </h4>
                  <p>
                    Good health is essential for learning and cognitive ability.
                    Ensuring good health when children are of school age can
                    boost attendance and educational achievement...
                  </p>
                  <button onClick={onOpenModal5} className="btn">
                    Read More
                  </button>
                  <Modal open={open5} onClose={onCloseModal5} center>
                    <h3>
                      Comprehensive Health & Wellness Program for School
                      students and their Family
                    </h3>
                    <div className="modal-body">
                      <p>
                        Good health is essential for learning and cognitive
                        ability. Ensuring good health when children are of
                        school age can boost attendance and educational
                        achievement. School children are often thought of as
                        naturally healthy, but studies have shown that in India,
                        more than half of the school children are shorter in
                        height and are anemic and are suffering from some or
                        other health problems.
                      </p>
                      <p>
                        Global and national initiatives to achieve universal
                        access to basic education mean that more children now
                        have the opportunity to go to school. As a result, more
                        children can be reached by the school system than ever
                        before. They need health interventions because most of
                        the children now attending school were previously beyond
                        the reach of both the education and health services.
                        Student comprehensive health programs can help ensure
                        that children are healthy and able to take full
                        advantage of what is often their first and only
                        opportunity for formal education.
                      </p>
                      <p>
                        Increasing numbers of countries have recognized the need
                        to ensure good health and development during the most
                        vulnerable early years of life. Integrated management of
                        childhood illness, early child development, and growth
                        monitoring and program assist parents and school to
                        ensure that a child enters school fit, well and ready to
                        learn. But the school age child continues to be at risk
                        of ill health, and the health of children, especially
                        girls, often deteriorates during the school years.
                      </p>

                      <p>
                        e-people plus School health Programme ensure that
                        children remain healthy during the years that are
                        critical for basic development and education.
                      </p>
                      <p>
                        e-people plus is a complete transactional smart Health
                        eco-system for recording and maintaining Health records
                        of students and provide them an environment for Smart
                        health preventive and reactive environment.
                      </p>
                      <p>
                        We have been taught from our childhood
                        <strong>"Health Is Wealth"</strong> and
                        <strong>"a Sound mind lives in a sound Body".</strong>
                        Health is essential for all our activities of life
                        whatever we may be – a doctor, a Leader or an artist, we
                        must possess a good health.
                      </p>
                      <p>
                        Healthy nation is a gift presented by parents and
                        teachers by implementing proactive and preventive health
                        care eco-solution in schools and homes. Schools and
                        Parents must providing pro-active &amp; preventive
                        health checks up on periodic basis and maintain:
                      </p>
                      <ul className="list">
                        <li>
                          Electronic Health Records of registered child health
                        </li>
                        <li>
                          Train the trainers for providing first aid services
                          and recording the same
                        </li>
                        <li>
                          Providing One to one sessions from Health specialists
                          for Health awareness for children and parents
                        </li>
                      </ul>

                      <p>
                        Our e-people plus eco-solution works on methodology with
                        a punch line
                        <strong>"Prevention is better than cure"</strong> and
                        execute this punch line by implementing automated
                        framework which is in scope as described below:
                      </p>
                      <ul className="list">
                        <li>
                          Register all Students of the school and provide them
                          with Co-branded Smart Health Card networked
                          neighborhood/distant clinics/hospitals, labs so that
                          the smart Health card is associated with student
                          identity and authentication management in School
                          premises along with entire e-people Plus health
                          eco-system. e-People Plus Smart Health card issued to
                          a Student will be a multi-purpose card and will act as
                          :
                          <ul className="list">
                            <li>o Student ID &amp; </li>
                            <li>o Health Card </li>
                          </ul>
                        </li>
                        <li>
                          School is provided an e-people plus portal access
                          where in First aid provided to students is recorded in
                          by local school Clinic doctor /Clinic staff.
                        </li>
                        <li>
                          School is registered for e-people plus portal and a
                          Separate one pager school highlight will be displayed
                          on e-people Plus Portal.
                        </li>
                        <li>
                          For Preventive and pro-active health implementation
                          for children our Health specialist /Doctors conduct
                          bi-annually medical checkup in school premises for
                          each and every student on following clinical
                          parameters:
                          <ul className="list">
                            <li>
                              General Physical Examination for Growth &amp;
                              Development
                            </li>
                            <li>Vision Assessment (Left and right Eye )</li>
                            <li>Hearing Assessment (Left ear and Right ear)</li>
                            <li>Dental Assessment</li>
                            <li>Learning Disability Detection</li>
                            <li>Obesity and sports fitness</li>
                            <li>General assessment by Doctor</li>
                          </ul>
                        </li>

                        <li>
                          Planned Electronic Health record of every child is
                          available on cloud which can be accessed anywhere thru
                          Portal Access by Students /Their parents /on e-people
                          plus registered clinics /Hospitals/lab Doctor Desk.
                        </li>
                        <li>
                          In time of illness a Student once referred/visit to
                          our networked clinics/hospitals/labs outside school
                          premises the Electronic Health record for OPD and IPD
                          visits are also recorded in our system which can be
                          accessed anytime anywhere as student Electronic Health
                          Record.
                        </li>
                        <li>
                          Year on Year Changes in Health Records are provided as
                          MIS dashboard to Schools and Parents on portal.
                        </li>
                        <li>
                          SMS/Email alerts are sent to parents for any concern
                          which are highlighted by our Health specialists so
                          that early detection and prevention is executed.
                        </li>
                        <li>
                          The eco-solution framework also provide
                          school/Children and their parents with an Emergency
                          Response center(24 X 7) responsible for responding
                          calls and delivering emergency services to a distress
                          citizens card request for medical emergencies like
                          ambulance and any other disaster/distress support
                          services.
                        </li>
                      </ul>

                      <h3>
                        <strong>
                          1.e-People Plus Student Comprehensive Health Program
                          features
                        </strong>
                      </h3>
                      <p>
                        Today everybody is talking about smart city environment
                        and with growth in mobility and social networks we
                        can-not imagine our life without our friends and near
                        and dear ones in our society and we call ourselves a
                        socially connected society. But, ironically our social
                        network so calls "Socially connected environment" failed
                        to give us smart and connected health environment which
                        is the need of an hour today.
                      </p>
                      <p>
                        There are various stakeholders of this smart and
                        connected School health eco-system which is actively
                        involved in providing safety and security providing
                        preventive and reactive health for Students thus
                        providing society a better health care connected
                        environment.
                      </p>
                      <p align="center">
                        <img alt="p1" className="w-100" src={p1} />
                      </p>
                      <p>
                        <b>
                          <u>
                            Multiple Usage contactless e-people Plus Smart card
                            for every student Feature of Eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        Students will be issued with a common card which will
                        have facilities as per School requirement Various
                        features can be availed as follows
                      </p>
                      <ul className="list">
                        <li>ID and Access Card</li>
                        <li>Heath Card</li>
                      </ul>
                      <p>
                        <b>
                          <u>
                            Electronic Medical Record Vault Feature of
                            Eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        For every Student of a school, the environment provides
                        a facility of Vault on cloud where all the Planned
                        records of students are stored as a centralized
                        repository. The students if treated outside at any of
                        e-people plus echo-system networked clinic/hospital than
                        all the records can be stored for external OPD ( Out
                        Door Patient Department ) and IPD (In Door Patient
                        Department) . in his/her allocated vault thus a
                        centralized repository is maintained for each and every
                        student as shown below:
                      </p>
                      <p align="center">
                        <img alt="p2" className="w-100" src={p2} />
                      </p>
                      <p>
                        <b>
                          <u>
                            Bi-Annual Comprehensive Health Checkup Feature of
                            eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        A team of specialist doctors in panel with e-people plus
                        will visit school onsite twice a year for planned
                        checkup of each and every student based on more than 100
                        health Parameters as mentioned below:
                      </p>
                      <ul className="list">
                        <li>
                          General Physical Examination for Growth &amp;
                          Development
                        </li>
                        <li>Vision Assessment (Left and right Eye)</li>
                        <li>Hearing Assessment (Left ear and Right ear)</li>
                        <li>Dental Assessment </li>
                        <li>Learning Disability Detection</li>
                        <li>Obesity and sports fitness </li>
                        <li>General assessment by Doctor </li>
                      </ul>

                      <p>
                        Each and every medical Record is stored in student
                        specific vault with complete detail along with duly
                        signed by doctor and School head/Responsible.
                      </p>
                      <p align="center">
                        <img alt="p3" className="w-100" src={p3} />
                      </p>
                      <p>
                        <b>
                          <u>
                            Emergency Response Radar Feature of Eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        e-People Plus eco-solution also provides a 24X7 facility
                        of e-people plus Emergency Response Centre (ERC) based
                        on GPS tracking/Landline and mobile telephony which is
                        responsible to respond to distress/Emergency calls of
                        registered students/schools to provide them a logistic
                        Ambulatory support from the vicinity so that during the
                        time of critical emergency registered students can be
                        transported to the nearest hospital at the earliest
                        without losing time and thus clinical support can be
                        provided during Golden hours.
                      </p>
                      <p>
                        Emergency Response Radar function &amp; features shown
                        below in figures below
                      </p>
                      <p align="center">
                        <img alt="p4" className="w-100" src={p4} />
                      </p>
                      <br />
                      <p align="center">
                        <img alt="p5" className="w-100" src={p5} />
                      </p>
                      <p>
                        Hence e-people plus eco-solution is truly a smart health
                        care environment providing proactive and reactive
                        approach both under single window platform.
                      </p>
                      <p align="center">
                        <img alt="p6" className="w-100" src={p6} />
                      </p>
                      <p>
                        <b>
                          <u>Portal Access Feature of Eco-solution</u>
                        </b>
                      </p>
                      <p>
                        The School can access e-people plus portal to access
                        School clinical application and school will be listed on
                        the portal under the category of Schools and Institutes
                        providing Comprehensive health programs.
                      </p>
                      <p>
                        Students and their parents can access their Electronic
                        Medical Records at any point in time by student/Their
                        parents from e-people plus portal and with Access to
                        portal Students/their family members can book an online
                        appointments for registered Hospitals/Clinics and can
                        utilize many other features associated with e-people
                        plus in case of any medical assistance.
                      </p>

                      <p align="center">
                        <img alt="p7" className="w-100" src={p7} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Turnkey Service" src={ProjectImg2} />
                  <h4>
                    Comprehensive Health & Wellness Program for corporate
                    employees and their Family
                  </h4>
                  <p>
                    We have been taught from our childhood "Health Is Wealth"
                    and "a Sound mind lives in a sound Body". Health is
                    essential for all our activities of life whatever we may be
                    – a doctor,...
                  </p>
                  <button onClick={onOpenModal6} className="btn">
                    Read More
                  </button>
                  <Modal open={open6} onClose={onCloseModal6} center>
                    <h3>
                      Comprehensive Health & Wellness Program for corporate
                      employees and their Family
                    </h3>
                    <div className="modal-body">
                      <p>
                        We have been taught from our childhood
                        <strong>"Health Is Wealth"</strong> and
                        <strong>"a Sound mind lives in a sound Body".</strong>
                        Health is essential for all our activities of life
                        whatever we may be – a doctor, a Leader or an artist, we
                        must possess a good health. Good health is essential for
                        overall productivity and more so for working force as
                        employee's overall health including physical and
                        psychological wellness effects his work and overall
                        Corporate productivity impacting corporate business
                        objectives . Health issues can result in absenteeism
                        impacting overall productivity. Many research has shown
                        that ensuring good health of employee's and their family
                        while they are contributing their efforts for corporate
                        growth boost employee morale, loyalty and productivity.
                      </p>
                      <p>
                        Healthy and happy employee should be corporate health
                        objective by implementing proactive and preventive
                        health care eco-solution for their corporate providing
                        pro-active &amp; preventive health checks up on periodic
                        basis and maintain:
                      </p>

                      <ul className="list">
                        <li>
                          Electronic Health Records of their workforce including
                          pre-joining medical check ups
                        </li>
                        <li>
                          Train the trainers for providing first aid services
                          and recording the same
                        </li>
                        <li>
                          Providing One to one sessions from Health specialists
                          for Health awareness for employees and their family
                        </li>
                      </ul>

                      <p>
                        Our e-people plus eco-solution works on methodology with
                        a punch line
                        <strong>"Prevention is better than cure"</strong> and
                        execute this punch line by implementing automated
                        framework which is in scope as described below:
                      </p>
                      <ul className="list">
                        <li>
                          Register all Employees of corporate and provide them
                          with Co-branded Smart Health Card which can be
                          accessed in networked neighborhood/distant
                          clinics/hospitals, labs and if corporate so wishes can
                          use the same smart Health card as employee identity
                          and authentication management in corporate premises
                          along with entire e-people Plus health eco-system. So
                          e-People Plus Smart Health card issued to a employee
                          will be a multi-purpose card and will act as:
                          <ul className="list">
                            <li>Employee ID</li>
                            <li>Health Card</li>
                          </ul>
                        </li>
                        <li>
                          Corporate l is provided an e-people plus portal access
                          where in First aid provided to employees is recorded
                          in by local corporate Clinic doctor/Clinic staff.
                        </li>
                        <li>
                          Corporate is registered for e-people plus portal and a
                          corporate highlight will be displayed on e-people Plus
                          Portal.
                        </li>
                        <li>
                          For Preventive and pro-active health implementation
                          for employees and their family members our Health
                          specialist/Doctors conduct bi-annually medical checkup
                          at corporate premises for each and every employee on
                          following clinical parameters:
                          <ul className="list">
                            <li>General Physical Examination</li>
                            <li>Vision Assessment (Left and right Eye)</li>
                            <li>Hearing Assessment (Left Ear and Right Ear)</li>
                            <li>Dental Assessment</li>
                            <li>Learning Disability Detection</li>
                            <li>Obesity and sports fitness</li>
                            <li>General assessment by Doctor </li>
                            <li>
                              Psychological and stress assessment By Doctor
                            </li>
                            <li>
                              Annual OPD Services for Selective Tests from our
                              Strategic Health care Partners
                            </li>
                          </ul>
                        </li>
                        <li>
                          Planned Electronic Health record of every employee and
                          his/her family is available on cloud which can be
                          accessed anywhere thru Portal Access by Health card
                          holder/their family/on e-people plus registered
                          clinics/Hospitals/lab Doctor Desk.
                        </li>
                        <li>
                          In time of illness of Employee once referred/visit to
                          our networked clinics/hospitals/labs outside corporate
                          premises the Electronic Health record for OPD and IPD
                          visits are also recorded in our system which can be
                          accessed anytime anywhere as employee Electronic
                          Health Record.
                        </li>
                        <li>
                          Year on Year Changes in Health Records are provided as
                          MIS dashboard to corporate and Family on portal.
                        </li>
                        <li>
                          SMS/Email alerts are sent to health card holder for
                          any concern which are highlighted by our Health
                          specialists so that early detection and prevention is
                          executed.
                        </li>
                        <li>
                          The eco-solution framework also provide corporate
                          employee/family with an Emergency Response center( 24
                          X 7) responsible for responding calls and delivering
                          emergency services to a distress citizens card request
                          for medical emergencies like ambulance and any other
                          disaster/distress support services.
                        </li>
                      </ul>

                      <h3>
                        1. e-People Plus Corporate Employee Comprehensive Health
                        Program Features
                      </h3>

                      <p>
                        Today everybody is talking about smart city environment
                        and with growth in mobility and social networks we
                        can-not imagine our life without our friends and near
                        and dear ones in our society and we call ourselves a
                        socially connected society. But, ironically our social
                        network so calls "Socially connected environment" failed
                        to give us smart and connected health environment which
                        is the need of an hour today.
                      </p>
                      <p>
                        There are various stakeholders of this smart and
                        connected School health eco-system which is actively
                        involved in providing safety and security providing
                        preventive and reactive health for corporate employees
                        thus providing society a better health care connected
                        environment.
                      </p>

                      <p align="center">
                        <img alt="c1" className="w-100" src={c1} />
                      </p>
                      <p>
                        <b>
                          <u>
                            Multiple Usage contactless e-people Plus Smart card
                            for every corporate employee Feature of Eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        Corporate employee will be issued with a health card
                        which will have facilities as per corporate requirement
                        Various features can be availed as follows:
                      </p>
                      <ul className="list">
                        <li>ID and Access Card </li>
                        <li>Heath Card </li>
                        <li>Pre-paid facility </li>
                      </ul>
                      <p>
                        <b>
                          <u>
                            Electronic Medical Record Vault Feature of
                            Eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        For every employee and his/her family member of a
                        corporate, the environment provides a facility of Vault
                        on cloud where all the Planned records of employee are
                        stored as a centralized repository. The person if
                        treated outside at any of e-people plus echo-system
                        networked clinic/hospital than all the records can be
                        stored for external OPD (Out Door Patient Department)
                        and IPD (In Door Patient Department). in his/her
                        allocated vault thus a centralized repository is
                        maintained for each and every student as shown below:
                      </p>
                      <p align="center">
                        <img alt="c2" className="w-100" src={c2} />
                      </p>
                      <p>
                        <b>
                          <u>
                            Bi-Annual Comprehensive Health Checkup Feature of
                            eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        A team of specialist doctors in panel with e-people plus
                        will visit corporate premises onsite twice a year for
                        planned checkup of each and every employee and their
                        family based on more than 100 health Parameters as
                        mentioned below:
                      </p>
                      <ul className="list">
                        <li>General Physical Examination</li>
                        <li>Vision Assessment (Left and right Eye)</li>
                        <li>Hearing Assessment (Left Ear and Right Ear)</li>
                        <li>Dental Assessment</li>
                        <li>Learning Disability Detection</li>
                        <li>Obesity and sports fitness </li>
                        <li>General assessment by Doctor </li>
                        <li>Psychological and stress assessment By Doctor</li>
                      </ul>

                      <p>
                        Each and every medical Record is stored in employee
                        specific vault with complete detail along with duly
                        signed by doctor and corporate head/Responsible.
                      </p>

                      <p align="center">
                        <img alt="c3" className="w-100" src={c3} />
                      </p>

                      <p>
                        <b>
                          <u>
                            OPD Selective Test Health Checkup Feature of
                            eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        Every employee and their family members are also
                        provided with OPD Selective test health checkups at our
                        strategic health care partners so that they can have
                        reactive health care also provided by eco-solution .
                      </p>
                      <p>
                        <b>
                          <u>
                            Emergency Response Radar Feature of Eco-solution
                          </u>
                        </b>
                      </p>
                      <p>
                        e-People Plus eco-solution also provides a (24 X 7)
                        facility of e-people plus Emergency Response Centre
                        (ERC) based on GPS tracking/Landline and mobile
                        telephony which is responsible to respond to
                        distress/Emergency calls of registered employees/family
                        to provide them a logistic Ambulatory support from the
                        vicinity so that during the time of critical emergency
                        registered students can be transported to the nearest
                        hospital at the earliest without losing time and thus
                        clinical support can be provided during Golden hours.
                      </p>
                      <p>
                        <b>
                          Emergency Response Radar function &amp; features shown
                          below in figures below:
                        </b>
                      </p>
                      <p align="center">
                        <img alt="c4" className="w-100" src={c4} />
                      </p>
                      <p align="center">
                        <img alt="c5" className="w-100" src={c5} />
                      </p>
                      <p>
                        Hence e-people plus eco-solution is truly a smart health
                        care environment providing proactive and reactive
                        approach both under single window platform.
                      </p>
                      <p align="center">
                        <img alt="c6" className="w-100" src={c6} />
                      </p>

                      <p>
                        <b>
                          <u>Portal Access Feature of Eco-solution</u>
                        </b>
                      </p>
                      <p>
                        The corporate can access e-people plus portal to access
                        corporate clinical application and corporate will be
                        listed on the portal under the category of corporate
                        providing Comprehensive health programs. Employees and
                        their family can access their Electronic Medical Records
                        at any point in time from e-people plus portal and with
                        Access to portal. Members can also book an online
                        appointments for registered Hospitals/Clinics and can
                        utilize many other features associated with e-people
                        plus in case of any medical assistance.
                      </p>

                      <p align="center">
                        <img alt="p7" className="w-100" src={p7} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Marketplace" src={alldaylogo} />
                  <h4>All Day Phygital Marketplace</h4>
                  <p>
                    Phygital Retail is an approach to combine the best element
                    of the Physical offline world with the Digital Online world
                    to create new type of shopping experiences and add more
                    value to customers buying experience.
                  </p>
                  <button onClick={onOpenModal7} className="btn">
                    Read More
                  </button>
                  <Modal open={open7} onClose={onCloseModal7} center>
                    <h3>All Day Phygital Marketplace</h3>
                    <div className="modal-body">
                      <p>
                        Phygital Retail is an approach to combine the best
                        element of the Physical offline world with the Digital
                        Online world to create new type of shopping experiences
                        and add more value to customers buying experience. India
                        is a nation of shopkeepers and as of 2022 November only
                        14% of the country's retail trade is organized or
                        modern. The rest is supported by small traders,
                        retailers and Mom & Pop store owners. In today's times
                        when the preferences of the customers are changing,
                        there is a need for change in the working and operations
                        of these un-organized or traditional store owners.
                        Traditional Retail store owners play an important role
                        in the Indian consumption ecosystem. The ongoing
                        disruption in traditional trade needs to be mitigated
                        through the modernization of retail stores.
                      </p>
                      <p>
                        Local neighbourhood shops /Retail need the support of a
                        digital retail ecosystem and to support this digital
                        ecosystem we came up with a B2B2C omni channel phygital
                        platform All-Day so that these local mom and pop stores
                        and other Retail businesses could compete with modern
                        days retail format. The gains from transforming an
                        informal sector into an organized one are considerable –
                        be it the increase in tax collection, the growth of
                        local businesses, or the positive impact on rural
                        consumptions and GDP.
                      </p>
                      <p>
                        All-Day mission is to bring each and every Retail
                        business dominated by retail standalone shop with an
                        online digital avatar. All-day is an omni-channel B2B2C
                        Phygital eco-system where we create on online retail
                        Stores and host them on cloud with complete e-commerce
                        backend engine by providing store a webstore, hosting
                        and a mobile application interface so that Retail
                        enterprise is capable of directly doing online trade
                        with consumer as a digital Business to consumer selling
                        and can overcome a challenge of survival from big
                        ecommerce players with consumers as D2C so that the
                        store can sell their products to the customers.
                      </p>
                      <p>
                        <strong>Phygital Touch points are:</strong>
                      </p>
                      <p>
                        <img className="w-100" alt="mp1" src={mp1} />
                      </p>
                      <p>
                        All-Day mission is to bring each and every Retail
                        business dominated by retail standalone shop with an
                        online digital avatar.
                      </p>
                      <p>
                        We are focussing on following business domains with Pan
                        India geolocation and with creation of B2B2C Retail
                        Stores Phygital Aggregator Platform.
                      </p>
                      <ul className="list with-50">
                        <li>Grocery & Organics </li>
                        <li>Restaurants </li>
                        <li>Apparels </li>
                        <li>Fashion Accessories </li>
                        <li>Pharma & Medicos </li>
                        <li>Pet Care </li>
                        <li>Automobile Spare Parts </li>
                        <li>Electrical & Lightings </li>
                        <li>Health & Medical Equipment </li>
                        <li>Office Home and hospital Furniture </li>

                        <li>Electronics Large appliances </li>
                        <li>Direct from Farms </li>
                        <li>Home Décor & Furnishing </li>
                        <li>Kitchen & Dining </li>
                        <li>Mobile & entertainment </li>
                        <li>Paints & Sanitary </li>
                      </ul>
                      <p>
                        All these business domains are most likely similar in
                        nature with respect to their online ordering and
                        integrated deliveries. Our following Platforms are
                        integrated tightly to provide Omnichannel All-day
                        Platform to give the best optimized result for these
                        domains. To make Store on All-Day we use Shoppenation
                        eco-solution which again is an IPR of Our Organization
                        All Day Digital. Shoppenation eco-system consist of
                        following Integrate Apps.
                      </p>
                      <p>
                        Shoppenation Store is a store automation Platform for
                        retailer/Partner Stores which provide retailer to
                        configure the cloud store in the most user-friendly way
                        with features like
                      </p>
                      <ul className="list">
                        <li>
                          Multiple Store Configurations with multi users &
                          multi-Role
                        </li>
                        <li>
                          Cloud store Creation and web published Products
                          Inventory management
                        </li>
                        <li>
                          Pricing and Discounts Module (with State Controlled
                          Pricing for Alcobev Industry)
                        </li>
                        <li>
                          Order Processing Workflow Consoles to handle O2O
                          Business Model
                        </li>
                        <li>Standard and Express Packaging </li>
                        <li>Order Delivery Dashboard </li>
                        <li>
                          POS (Self Take away, Delivery Aggregators & Walk-in)
                        </li>
                        <li>Value added Services for Store Promotions </li>
                        <li>
                          Business to business Ordering System with
                          Intermediatories like Distributors /stockists or
                          Directly from Brands
                        </li>
                        <li>
                          Accounts Receivables and payables & Invoice
                          settlements
                        </li>
                      </ul>
                      <p>
                        Shoppenation Warehouse management System is system for
                        Ware house Management which provides retailers to
                        configure their Warehouses and manage their warehouses
                        Inventory
                      </p>
                      <p>
                        All-day Delivery Centre is a Delivery Centre application
                        where in multiple Last mile delivery Centre enterprises
                        are Configured with All-day Platforms and provide
                        following features
                      </p>
                      <ul className="list">
                        <li>
                          Delivery Centre configurations with delivery
                          categories
                        </li>
                        <li>Vahan and Vahan Chalak Configurations </li>
                        <li>Vahan Geo Mappings </li>
                        <li>Vahan Scheduler </li>
                        <li>Account receivables & Payables </li>
                      </ul>
                      <p>
                        Our Delivery Rider Application Shoppenation Vahan is a
                        vehicle Driver application tightly integrated with
                        All-day order Processing and associated deliveries to
                        All-Day Retail Stores customer and from Suppliers to the
                        All-Day Partner Retail stores warehouses with features
                        of
                      </p>
                      <ul className="list">
                        <li>Daily Trip Schedules</li>
                        <li>Ask Store Utility </li>
                        <li>Order Collections from Stores </li>
                        <li>Optimized route Formation </li>
                        <li>Order Delivery to customers </li>
                        <li>On duty & Off duty Utility </li>
                      </ul>
                      <p>Providing Following Value proposition</p>
                      <p>
                        <img className="w-100" alt="mp2" src={mp2} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Turnkey Service" src={ProjectImg2} />
                  <h4>Turnkey Service Providers for Health Care Industry</h4>
                  <p>
                    We are Leading Turnkey Hospital Program managers and
                    Implementation Providers. We are Health catalyst for
                    Hospitals and our objective is to provide highest quality...
                  </p>
                  <button onClick={onOpenModal8} className="btn">
                    Read More
                  </button>
                  <Modal open={open8} onClose={onCloseModal8} center>
                    <h3>Turnkey Service Providers for Health Care Industry</h3>
                    <div className="modal-body">
                      <p>
                        We are Leading Turnkey Hospital Program managers and
                        Implementation Providers. We are Health catalyst for
                        Hospitals and our objective is to provide highest
                        quality whole nine-yard health care Infrastructure and
                        services Keeping in mind that the hospital gets the
                        highest Possible ROI from Health care infrastructure
                        investments. The leadership team has more than 100 Man
                        Years' of International experience to deliver Health
                        care providers/Hospital turnkey Projects.
                      </p>
                      <p>
                        <img alt="ts1" className="w-100" src={ts1} />
                      </p>
                      <p>
                        Here Turnkey Implementation in simple words indicates
                        Hospital IT & Non-IT Infrastructure Includes Health care
                        Facility Plan that meets the international health care
                        planning, Standards and guidelines with focus on
                        patients and other occupant's safety, ergonomic, state
                        of the art functionality appropriate cost-effective
                        design/development, implementation & post
                        -implementation support under one Turnkey Provider
                        Umbrella (includes following activities)
                      </p>
                      <p>
                        <strong>Program Management for Hospital</strong>
                      </p>
                      <ul className="list">
                        <li>
                          Health care Facility Plan and hospital infrastructure
                          development framework with complete onus to get
                          hospital services up and running as per schedule with
                          resources and development /institutionalization of
                          risk mitigation and escalation management
                        </li>

                        <li>
                          Single point of contact Command Centre implementation
                          for statement of applicability (SOA's) for Products
                          and services
                        </li>
                        <li>
                          Development of build, operate & manage framework for
                          the hospital and its institutionalization
                        </li>
                      </ul>
                      <p>
                        <strong>
                          Implementation of Products/Services for Hospital
                        </strong>
                      </p>
                      <ul className="list">
                        <li>
                          Hospital Infrastructure Assets (IT and Non-IT)
                          requirement gathering and Procurement Process
                        </li>
                        <li>
                          Commissioning of Products and Services as per
                          consolidate timelines and SLA's
                        </li>
                        <li>
                          Commissioning of Post Implementation support under
                          Command Centre as per defined SLAs
                        </li>
                      </ul>
                      <p>
                        <img alt="ts2" className="w-100" src={ts2} />
                      </p>
                      <br />
                      <p>
                        <img alt="ts3" className="w-100" src={ts3} />
                      </p>
                      <br />
                      <p>
                        <img alt="ts4" className="w-100" src={ts4} />
                      </p>
                      <p>
                        <strong>
                          Advantages for turnkey implementation for hospitals
                          are
                        </strong>
                      </p>
                      <ul className="list">
                        <li>
                          Health Care Providers and Hospitals to focus on their
                          core competencies "Health Care" Business and Market
                        </li>
                        <li>
                          Hospitals to Stay low in IT and Non-IT Infrastructure
                          management cost and under budgetary control even while
                          the hospital is on growth path.
                        </li>
                        <li>
                          Ability to get measurable service levels from IT and
                          Non-IT operations and infrastructure with consolidated
                          operational service model including business
                          continuity
                        </li>
                        <li>
                          Move from reactive management to pro-active management
                        </li>
                        <li>
                          Technology and Infrastructure well defined Industry
                          process in place
                        </li>
                        <li>
                          Empower employees to function at a higher-level oaf
                          achievements & Knowledge retention
                        </li>
                        <li>
                          Steps towards ideal IT and Non-IT operations and
                          Infrastructure managed hospital
                        </li>
                        <li>Faster Roll-out of new services</li>
                        <li>
                          TCO and hospital resources under Management control
                        </li>
                      </ul>
                      <p>
                        <strong>
                          Methodology we follow to implement Turnkey Provider
                          approach
                        </strong>
                      </p>
                      <p>
                        We Follow Build, Operate and Manage (BOM) Framework
                        Methodology to implement above mentioned two pillars for
                        our turnkey Hospital.
                      </p>
                      <p>
                        <img alt="ts5" className="w-100" src={ts5} />
                      </p>
                      <p>
                        Our BOM methodology is thirteen (13) Steps Framework
                        which is dedicated steps for process formation,
                        Implementation & Institutionalization to deliver world
                        class Hospital with in projected timelines and under
                        budgetary controls. To implement turnkey Hospitals for
                        allocated statement of applicability (SOA's) we have
                        various Industry associations which are mentioned in our
                        channel partner’s section.
                      </p>
                      <p>
                        Some of our MENA Sites turnkey implementation experience
                      </p>
                      <p>
                        <img alt="ts6" className="w-100" src={ts6} />
                      </p>
                    </div>
                  </Modal>
                </div>
              </div>

              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <div className="product-box">
                  <img alt="Turnkey Service" src={alldaylogo} />
                  <h4>Turnkey Service Provider for Higher Education Industry</h4>
                  <p>We are Leading Turnkey solution Providers for Higher Education Institutes and Universities and
                    our objective is to provide highest quality whole nine-yard...

                  </p>
                  <button onClick={onOpenModal9} className="btn">
                    Read More
                  </button>
                  <Modal open={open9} onClose={onCloseModal9} center>
                    <h3>Turnkey Service Provider for Higher Education Industry</h3>
                    <div className="modal-body">
                      <p><strong>All-Day Higher Education Industry Verticals</strong></p>
                      <p>
                        We are Leading Turnkey solution Providers for Higher Education Institutes and Universities and our objective is to provide highest quality whole nine-yard solution from conceptualization to commissioning and managing the same Infrastructure and services Keeping in mind that the Universities and Academic institutes gets the highest Possible ROI from existing and new infrastructure investments. The leadership team has more than 100 Man Years of International experience to deliver University & Academic Institutes turnkey and consulting Projects.
                      </p>
                      <p><strong>Our Service offering from conceptualization to commissioning are:</strong></p>
                      <p>
                        <img alt="edu5" className="w-100" src={edu5} />
                      </p>
                            
                  
                  
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
          </HeaderInfo>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
